import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
function mapRank(r) {
    return {
        rankName: r.RankName,
        ncRatio: `${r.NcRatio.toFixed(2)}%`,
    };
}
export function NcRankHotspotTable({ options }) {
    const [isFetching, setIsFetching] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [allRanks, setAllRanks] = useState([]);
    const [topN, setTopN] = useState(5);
    const isLoading = !options.isReady || isFetching;
    const ranks = allRanks.slice(0, topN);
    useEffect(() => {
        if (!options.isReady) {
            setHasResult(false);
            setIsFetching(false);
            setErrorMessage("");
            return;
        }
        setIsFetching(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/ranks/hotspots?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setAllRanks(data === null ? [] : data.filter((r) => r.NcRatio > 0).map(mapRank));
            setHasResult(true);
        })
            .catch((e) => {
            console.error(e);
            setErrorMessage("Error fetching rank hotspots");
        })
            .finally(() => setIsFetching(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    return (_jsxs("div", { className: "card shadow", children: [_jsxs("div", { className: "card-header d-flex align-items-center justify-content-between", children: [_jsx("h3", { className: "mb-0", children: "Ranks with highest ratio of NC hours over worked hours" }), _jsxs("select", { className: "form-select form-select-sm w-auto", value: topN, onChange: (e) => setTopN(Number(e.target.value)), children: [_jsx("option", { value: "5", children: "Top 5" }), _jsx("option", { value: "10", children: "Top 10" }), _jsx("option", { value: "20", children: "Top 20" })] })] }), _jsxs("div", { className: "card-body", children: [isLoading && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && ranks.length > 0 && (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm align-middle mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Rank" }), _jsx("th", { className: "text-end", children: "NC hours / Worked hours" })] }) }), _jsx("tbody", { children: ranks.map((r, index) => (_jsxs("tr", { children: [_jsx("td", { children: r.rankName }), _jsx("td", { className: "text-end", children: r.ncRatio })] }, index))) })] }) })), hasResult && !isLoading && ranks.length === 0 && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
}
